// @ts-nocheck
/* eslint-disable */
export const appChevronRight40Icon = {
    data: `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5 12L24 20.5L15.5 29" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'chevron-right-40' as const
};